import {Service} from "@/services/superclasses/service";
import {SupplementList} from "@/interfaces/supplement-list";

const api = window.contextPath + '/rest/supplements';

export class SupplementService extends Service {

    public search = async (args: {
        member?: number,
        q?: string,
        featured?: boolean,
        first?: number,
        max?: number
    }): Promise<SupplementList[]> => {
        return this.data(await this.get<SupplementList[]>(api + "/",
            {
                params: args
            }))
    }

    public count = async (args: {
        member?: number,
        q?: string,
        featured?: boolean
    }): Promise<number> => {
        return this.data(await this.get<number>(api + "/count",
            {
                params: args
            }))
    }
}

export const supplementService = new SupplementService()